import CalendarioLetivoIndexPage from "@/Pages/CalendarioLetivo/index.vue";
import NewEditCalendarioLetivoPage from "@/Pages/CalendarioLetivo/NewEditCalendarioLetivoPage.vue";
import ShowCalendarioLetivoPage from "@/Pages/CalendarioLetivo/ShowCalendarioLetivoPage.vue";
import CalendarioLetivoPage from "@/Pages/CalendarioLetivo/CalendarioLetivoPage.vue";
import { can } from "@/plugins/can";

export default [
  {
    path: "/calendario-letivo/create",
    name: "calendario-letivo.create",
    component: NewEditCalendarioLetivoPage,
    props: { editing: false },
    beforeEnter(to, from, next) {
      if (!can(["calendarioLetivo.*", "calendarioLetivo.calendariosIndex"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
  {
    path: "/calendario-letivo/edit/:circuito_id",
    name: "calendario-letivo.edit",
    component: NewEditCalendarioLetivoPage,
    props: { editing: true },
    beforeEnter(to, from, next) {
      if (!can(["calendarioLetivo.*", "calendarioLetivo.calendariosIndex"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
  {
    path: "/calendario-letivo/etapas/:circuito_id",
    name: "calendario-letivo.etapas",
    component: CalendarioLetivoPage,
    props: { editing: true },
  },
  {
    path: "/calendario-letivo/show/:circuito_id",
    name: "calendario-letivo.show",
    component: ShowCalendarioLetivoPage,
    props: { editing: true },
    beforeEnter(to, from, next) {
      if (!can(["calendarioLetivo.*", "calendarioLetivo.calendariosShow"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
];
